export const __badge = ({ theme, variant, mr, height }) => {
	const bgVariants = {
		soldOut: {
			bg: theme.colors.lightGrey3,
			border: 'none',
		},
		fastFilling: {
			bg: theme.colors.orange,
			border: 'none',
		},
		available: {
			bg: theme.colors.white,
			border: `1px solid ${theme.primary(theme).backgroundColor}`,
		},
		date: {
			bg: theme.colors.bmsDarkBlue,
			borderRadius: 'none',
		},
		live: {
			bg: theme.colors.bmsPink,
			border: 'none',
		},
		chip: {
			bg: theme.colors.bmsDeepBlue,
			border: 'none',
		},
		onHold: {
			bg: theme.colors.errorRed,
			border: 'none',
		},
	}

	return {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: height || theme.font.size16,
		background: bgVariants[variant].bg,
		borderRadius: '2px',
		border: bgVariants[variant].border,
		padding: '0 6px',
		marginRight: mr && theme.spaces[mr],
	}
}
